package com.tixforgigs.common.ui.components.mandarin

import com.tixforgigs.apax.models.TermsAndConditions
import com.tixforgigs.common.core.annotations.MissingTaramiMessageKey
import com.tixforgigs.common.core.enums.MandarinCheckboxType
import com.tixforgigs.common.core.extensions.orElse
import com.tixforgigs.common.core.models.ui.InputState
import com.tixforgigs.common.core.util.IdHelper.generateRandomId
import com.tixforgigs.tarami.AraiMessage.inputCheckboxPrefillFirstPersonalization
import com.tixforgigs.tarami.AraiMessage.inputCheckboxResalePrivateLabel
import com.tixforgigs.tarami.AraiMessage.messageTermsApply
import com.tixforgigs.tarami.GlobalMessage.textLinkGTC
import com.tixforgigs.tarami.GlobalMessage.textTermsApply
import io.kvision.core.Container
import io.kvision.core.Cursor
import io.kvision.event.changeFlow
import io.kvision.html.label
import io.kvision.html.link
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.checkbox.checkbox
import io.kvision.material.widget.TouchTarget
import io.kvision.panel.simplePanel
import io.kvision.state.bind
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update

@OptIn(ExperimentalMaterialApi::class)
fun <T> Container.mandarinCheckbox(
  state: MutableStateFlow<InputState<Boolean>>,
  checkboxType: MandarinCheckboxType,
  item: T? = null,
  onClick: suspend () -> Unit = {}
) {
  val checkboxId = generateRandomId(numbersAllowed = false)
  simplePanel(className = "xm-checkbox-panel") {
    checkbox(className = "xm-checkbox") {
      id = checkboxId
      touchTarget = TouchTarget.Wrapper
    }.bind(state) { state ->
      checked = state.inputValue
    }.changeFlow.onEach {
      state.update { it.copy(inputValue = it.inputValue.not(), isValid = true) }
      onClick()
    }.launchIn(MainScope())

    label(
      forId = checkboxId,
    ) {
      cursor = Cursor.POINTER
      when (checkboxType) {
        MandarinCheckboxType.PRIVATE_RESALE -> +inputCheckboxResalePrivateLabel()
        @MissingTaramiMessageKey
        MandarinCheckboxType.TEMPLATE_CONFIG_SEARCH_ENABLED -> +"Suche aktivieren"

        @MissingTaramiMessageKey
        MandarinCheckboxType.TEMPLATE_CONFIG_DETAIL_DESCRIPTION_ENABLED -> +"Detailansicht aktivieren"

        MandarinCheckboxType.PREFILL_FIRST_PERSONALIZATION -> +inputCheckboxPrefillFirstPersonalization()
        MandarinCheckboxType.TERMS_AND_CONDITIONS -> {
          when (item) {
            is TermsAndConditions -> {
              +item.company?.let { company ->
                messageTermsApply(company)
              }.orElse { textTermsApply() }.plus(" ")
              item.url?.let { url ->
                link(
                  label = textLinkGTC(),
                  url = url,
                  target = "_blank",
                  dataNavigo = false
                )
              }
            }
          }
        }
      }
    }
  }
}